/** How the player's account was created, from `Enums.MembershipTypes`. */
export const MembershipType = {
  Member: 0,
  Onetime: 1,
  Anonymous: 2,
  AnonymousReservation: 3,
} as const;

export type MembershipType = (typeof MembershipType)[keyof typeof MembershipType];

/** Which identifier the quick registration form asks for. */
export const FastRegisterType = {
  Username: 0,
  Phone: 1,
  Both: 2,
} as const;

export type FastRegisterType = (typeof FastRegisterType)[keyof typeof FastRegisterType];

export const ChatProvider = {
  Zendesk: 0,
  LiveChat: 1,
  Tawk: 2,
  Comm100: 3,
  TugiAI: 4,
} as const;

export type ChatProvider = (typeof ChatProvider)[keyof typeof ChatProvider];

/**
 * Legacy brand theme colours, kept only to read the value the API stores against a
 * player profile. New theming goes through `src/theme`, not this list.
 */
export const LegacyThemeColor = {
  yellow: 0,
  green: 1,
  orangeOld: 2,
  lightorange: 3,
  purple: 4,
  black: 5,
  greenblack: 6,
  sunset: 7,
  ocean: 8,
  sahara: 9,
  blue: 10,
  limegreen: 11,
  blackgold: 12,
  orange: 13,
  tiger: 14,
  monochrome: 15,
  darkocean: 17,
  darkyellow: 18,
  midnight: 19,
  bluedark: 22,
  bluelight: 23,
  reddark: 24,
  redlight: 25,
} as const;

export type LegacyThemeColor = (typeof LegacyThemeColor)[keyof typeof LegacyThemeColor];
